export const ALL_STATES_LABEL = 'All States';

const ALL_STATES_DB_VALUES = ['ALLSTATES', 'MULTI'];

const normalizeState = (state: string) => state.replace(/[\s_]/g, '').toUpperCase();

export const isAllStatesPolicyState = (state?: string | null): boolean =>
  !!state && ALL_STATES_DB_VALUES.includes(normalizeState(state));

export const getPolicyStateLabel = (state: string): string =>
  isAllStatesPolicyState(state) ? ALL_STATES_LABEL : state;

export const sortWithAllStatesFirst = <T>(items: T[], getState: (item: T) => string): T[] =>
  [...items].sort(
    (a, b) =>
      Number(isAllStatesPolicyState(getState(b))) - Number(isAllStatesPolicyState(getState(a))) ||
      getState(a).localeCompare(getState(b))
  );
